import NliAnnouncementModal from './NliAnnouncementModalComponent';
export default NliAnnouncementModal;